import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import Page from "@/components/Page";
import ShopThemeProvider from "@/components/organisations/shop/ShopThemeProvider";
import { ERROR_404_URL } from "@/core/urls";
import useDocTitle from "@/hooks/use-doc-title";
import DashboardSwitcher from "@/tpo/DashboardSwitcher";

import Course from "./Course";
import Courses from "./Courses";
import Dashboard from "./Dashboard";
import Event from "./Event";
import Events from "./Events";
import FAQS from "./FAQS";
import SupportDocuments from "./SupportDocuments";
import VideoGuide from "./VideoGuide";
import VideoGuides from "./VideoGuides";
import Webinar from "./Webinar";
import Webinars from "./Webinars";

export default function KnowledgeBase() {
  const match = useRouteMatch();
  useDocTitle("Learning hub", false, "Regenerus");

  return (
    <Switch>
      <Redirect exact path={match.path} to={`${match.url}/dashboard`} />
      <Route path={`${match.path}/dashboard`} exact>
        <Page bg="haze" includeFooter addNavBarHeight={false}>
          <DashboardSwitcher bg="partners" isPartnerPage title="Learning hub" />
          <Dashboard />
        </Page>
      </Route>
      <Route path={match.path}>
        <ShopThemeProvider>
          <Switch>
            <Route path={`${match.path}/courses`} exact>
              <Page bg="haze" includeFooter addNavBarHeight={false}>
                <DashboardSwitcher bg="partners" isPartnerPage title="Learning hub" />
                <Courses />
              </Page>
            </Route>
            <Route path={`${match.path}/courses/:slug`} exact>
              <Page bg="white" includeFooter addNavBarHeight={false}>
                <Course />
              </Page>
            </Route>
            <Route path={`${match.path}/events`} exact>
              <Page bg="haze" includeFooter addNavBarHeight={false}>
                <DashboardSwitcher bg="partners" isPartnerPage title="Learning hub" />
                <Events />
              </Page>
            </Route>
            <Route path={`${match.path}/events/:slug`} exact>
              <Page bg="white" includeFooter addNavBarHeight={false}>
                <Event />
              </Page>
            </Route>
            <Route path={`${match.path}/faqs`} exact>
              <Page bg="haze" includeFooter addNavBarHeight={false}>
                <DashboardSwitcher bg="partners" isPartnerPage title="Learning hub" />
                <FAQS />
              </Page>
            </Route>
            <Route path={`${match.path}/support_documents`} exact>
              <Page bg="haze" includeFooter addNavBarHeight={false}>
                <DashboardSwitcher bg="partners" isPartnerPage title="Learning hub" />
                <SupportDocuments />
              </Page>
            </Route>
            <Route path={`${match.path}/webinars`} exact>
              <Page bg="haze" includeFooter addNavBarHeight={false}>
                <DashboardSwitcher bg="partners" isPartnerPage title="Learning hub" />
                <Webinars />
              </Page>
            </Route>
            <Route path={`${match.path}/webinars/:slug`} exact>
              <Page bg="haze" includeFooter addNavBarHeight={false}>
                <Webinar />
              </Page>
            </Route>
            <Route path={`${match.path}/video_guides`} exact>
              <Page bg="haze" includeFooter addNavBarHeight={false}>
                <DashboardSwitcher bg="partners" isPartnerPage title="Learning hub" />
                <VideoGuides />
              </Page>
            </Route>
            <Route path={`${match.path}/video_guides/:slug`} exact>
              <Page bg="haze" includeFooter addNavBarHeight={false}>
                <VideoGuide />
              </Page>
            </Route>
            <Redirect to={ERROR_404_URL} />
          </Switch>
        </ShopThemeProvider>
      </Route>
    </Switch>
  );
}
